import Partner, { IPartner } from 'components/Partner/Partner';
import withCountry from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import withPartnersPageQuery, { WithPartnersPageQueryProps } from 'enhancers/withPartnersPageQuery';
import * as React from 'react';
import Placeholder from 'react-placeholder';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';

type Props = WithPartnersPageQueryProps & WithLanguageProps;

export const PartnersPage: React.SFC<Props> = props => {
  const background =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Partners &&
    props.data.fetch.Common.Partners.BackgroundColor
      ? props.data.fetch.Common.Partners.BackgroundColor
      : '#ffffff';
  const color = getTextColor(background);
  const partners: IPartner[] =
    !props.loading && props.data && props.data.fetch.Country.AboutPage.Partners
      ? props.data.fetch.Country.AboutPage.Partners.map(partner => ({
          content: props.getText(partner.Content),
          image: partner.PartnerImage.src,
          title: props.getText(partner.Name)
        }))
      : [];

  const highlightBackground =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Partners &&
    props.data.fetch.Common.Partners.HighlightColor
      ? props.data.fetch.Common.Partners.HighlightColor
      : '#ffffff';
  return (
    <Container style={{ background, color }}>
      <Placeholder
        showLoadingAnimation={true}
        ready={!props.loading}
        type="rect"
        style={{ height: 300 }}
      >
        {partners.map((partner, i) => (
          <Partner
            hightlightBackground={highlightBackground}
            direction={i % 2 ? 'left' : 'right'}
            key={i}
            {...partner}
          />
        ))}
      </Placeholder>
    </Container>
  );
};

const Container = styled.div`
  padding-top: 25px;
`;

export default withLanguageState(
  withCountry(withPartnersPageQuery(PartnersPage))
);



// WEBPACK FOOTER //
// ./src/pages/PartnersPage/PartnersPage.tsx